import React from 'react';
import Image from '@atlaskit/image';
import { Popper } from '@atlaskit/popper';
import { injectIntl, type WrappedComponentProps } from 'react-intl-next';
import { type Template, TemplateType } from '../../containers/template/types';
import { HoverPreviewContainer, TemplateInfo, Icon, TemplateName, Preview } from './styled';

interface Props {
	template?: Template;
	boundaryRef: React.RefObject<HTMLElement>;
	onMouseEnter: (event: React.MouseEvent) => void;
	onMouseLeave: (event: React.MouseEvent) => void;
}

const HoverPreview = ({
	template,
	boundaryRef,
	onMouseEnter,
	onMouseLeave,
	intl,
}: Props & WrappedComponentProps) => {
	if (!template || template.type !== TemplateType.Confluence) {
		return null;
	}
	return (
		<Popper
			placement="left"
			modifiers={[
				{ name: 'offset', options: { offset: [0, 32] } },
				{
					name: 'preventOverflow',
					options: {
						// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
						padding: 16,
						boundary: boundaryRef.current || undefined,
					},
				},
			]}
			strategy="absolute"
		>
			{({ ref, style }) => (
				<HoverPreviewContainer
					innerRef={ref || undefined}
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					style={style}
					onMouseEnter={onMouseEnter}
					onMouseLeave={onMouseLeave}
				>
					<TemplateInfo>
						<Icon>
							{template.iconRender({
								size: 'small',
								color: template.defaultIconColor,
							})}
						</Icon>
						<TemplateName>{intl.formatMessage(template.name)}</TemplateName>
					</TemplateInfo>
					<Preview>
						<Image
							src={template.preview.postExpand.default}
							srcDark={template.preview.postExpand.dark}
							width="100%"
							alt={`${template.name} Confluence Template`}
						/>
					</Preview>
				</HoverPreviewContainer>
			)}
		</Popper>
	);
};

export default injectIntl(HoverPreview);
